import { render, staticRenderFns } from "./ChatQuestion.vue?vue&type=template&id=76a786ce&"
import script from "./ChatQuestion.vue?vue&type=script&lang=js&"
export * from "./ChatQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports